import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { Modal, Box, Typography, Button, Grid } from "@mui/material";
import PageHeader from "../ui/PageHeader";
import CustomInput from "../ui/CustomInput";
import axios from "../../api/axiosClient";
import { useLoading } from "../LoadingContext";
import { handleError } from "../../services/serviceBase";
import { useNavigate } from "react-router-dom";

const ForceClosureModal = (props) => {
  const modalStyle = {
    position: "relative",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: "5px",
    width: 500,
  };

  const intl = useIntl();
  const { setLoading } = useLoading();
  const [note, setNote] = useState("");
  const navigate = useNavigate();

  const handleClose = () => {
    props.handleCloseModal();
  };

  useEffect(() => {
    getExistingNotes();
  }, [props.openModal]);

  const getExistingNotes = async () => {
    setLoading(true);
    axios
      .get("/returnfiles/" + props.idReturnFileHead + "/notes")
      .then((response) => {
        setLoading(false);
        setNote(response.data);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const forceRAClosing = () => {
    setLoading(true);
    const params = new URLSearchParams([]);
    if (note != "") {
      params.append("notes", note);
    }
    let url = "returnFiles/" + props.idReturnFileHead + "/forcedclosure";
    if (params.size > 0) {
      url += "?" + params.toString();
    }
    axios
      .post(url)
      .then(() => {
        setLoading(false);
        navigate("/RASearch");
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  return (
    <Modal open={props.openModal} onClose={handleClose}>
      <Box sx={modalStyle}>
        <Grid container>
          <Grid item lg={12} mb={1}>
            <PageHeader
              title={intl.formatMessage({ id: "RADetails.ForcedClosing" })}
            />
          </Grid>
          <Grid item lg={12} mb={1}>
            <CustomInput
              labelText={intl.formatMessage({ id: "RADetails.Notes" })}
              type="textMultiline"
              value={note}
              setValue={setNote}
              textCol={2}
              inputCol={10}
            />
          </Grid>
          <Grid item lg={12}>
            <Button
              variant="outlined"
              style={{
                backgroundColor: "#85abd5",
                color: "white",
                borderColor: "#85abd5",
              }}
              sx={{ width: "100%" }}
              onClick={(e) => forceRAClosing()}
            >
              {intl.formatMessage({ id: "General.Save" })}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default ForceClosureModal;
